import { useQuery } from '@tanstack/react-query';
import { ROUTES, type Quotation } from '@serb/shared';
import { api, errorText } from '../../api/client';
import { KEYS } from '../../api/keys';
import { SAMPLE_DATA } from '../../lib/sample';
import { blankShipment, SHIPMENTS, type Shipment } from '../shipments/sample';
import { useShipments } from '../shipments/useShipments';
import { QUOTATIONS } from './sample';

/** The quotations kept in the Serb Mind vault (made-up ones only while sample data is on), and the shipment each one is for */
export function useQuotations() {
  const q = useQuery({
    queryKey: KEYS.quotations,
    queryFn: () => api.get<Quotation[]>(ROUTES.api.quotations),
    enabled: !SAMPLE_DATA,
  });
  const { items: ships } = useShipments();
  const shipmentOf = (x: Quotation): Shipment =>
    ships.find((s) => s.srb === x.srb) ?? SHIPMENTS.find((s) => s.srb === x.srb) ?? blankShipment(x.srb, x.client);
  return {
    items: SAMPLE_DATA ? QUOTATIONS : (q.data ?? []),
    loading: !SAMPLE_DATA && q.isPending,
    error: q.isError ? errorText(q.error, 'The quotations could not be loaded.') : '',
    shipmentOf,
  };
}
